import {SVGMotionProps, Variants, motion, useAnimation} from 'framer-motion';
import * as React from 'react';

const lineVariants: Variants = {
  initial: {
    opacity: 0,
  },
  animate: {
    opacity: 1,
    transition: {
      delay: 1,
      duration: 1.5, // Animation duration in seconds
      ease: 'easeInOut', // Animation easing
    },
  },
};

const buttonVariants: Variants = {
  initial: {
    opacity: 0,
  },
  animate: {
    opacity: 1,
    transition: {
      delay: 2,
      duration: 0.5,
      ease: 'easeInOut',
    },
  },
};

type Props = React.HTMLAttributes<SVGSVGElement> &
  SVGMotionProps<SVGSVGElement> & {isActive: boolean};

const StepFourDiagram: React.FC<Props> = ({isActive, ...props}) => {
  const lineController = useAnimation();
  const buttonController = useAnimation();

  React.useEffect(() => {
    if (isActive) {
      const sequence = () => {
        lineController.start('animate');
        buttonController.start('animate');
      };
      sequence();
    }
  }, [isActive, lineController, buttonController]);

  return (
    <motion.svg
      xmlns="http://www.w3.org/2000/svg"
      width={300}
      height={300}
      fill="none"
      {...props}
    >
      <motion.path
        id="line"
        fill="#fff"
        fillRule="evenodd"
        d="M20 12.5a.5.5 0 0 1 .5.5v258c0 8.56 6.94 15.5 15.5 15.5h228c8.56 0 15.5-6.94 15.5-15.5V13a.5.5 0 0 1 1 0v258c0 9.113-7.387 16.5-16.5 16.5H36c-9.113 0-16.5-7.387-16.5-16.5V13a.5.5 0 0 1 .5-.5Z"
        clipRule="evenodd"
        initial="initial"
        animate={lineController}
        variants={lineVariants}
        strokeWidth={1}
        strokeDasharray="0 1"
      />
      <motion.path
        variants={buttonVariants}
        initial="initial"
        animate={buttonController}
        fill="#fff"
        d="M186.189 202.305A35.964 35.964 0 0 0 188 191c0-19.882-16.118-36-36-36s-36 16.118-36 36 16.118 36 36 36a35.847 35.847 0 0 0 16.361-3.924l-3.515-2.759A31.896 31.896 0 0 1 152 223c-17.673 0-32-14.327-32-32 0-17.673 14.327-32 32-32 17.673 0 32 14.327 32 32 0 3.444-.544 6.761-1.551 9.87l3.74 1.435Z"
      />
      <motion.path
        variants={buttonVariants}
        initial="initial"
        animate={buttonController}
        fill="#fff"
        d="m185.317 204.663-3.741-1.425a32.116 32.116 0 0 1-14.216 15.841l3.295 2.581c.016.017.032.028.045.037.021.014.036.024.037.049a36.133 36.133 0 0 0 14.58-17.083Z"
      />
      <motion.path
        variants={buttonVariants}
        initial="initial"
        animate={buttonController}
        fill="#fff"
        d="m165.636 217.729-5.447-4.266c-.02 0-.031-.011-.041-.022-.01-.011-.02-.023-.041-.023a1.738 1.738 0 0 1-.736-1.425c0-.936.695-1.693 1.554-1.693.175 0 .319.032.485.07l.087.019c.024.026.034.037.046.041.009.004.019.004.036.004l6.91 3.163c.327.133.695.133.981-.045.286-.134.531-.445.613-.802l.572-1.96c.041-.089.041-.223.041-.312l.491-19.201c0-.936.695-1.693 1.554-1.693.858 0 1.553.757 1.553 1.693v.044l.368 8.42c0 .535.327.981.777 1.159l4.267 1.626a30.115 30.115 0 0 1-14.07 15.203Z"
      />
      <motion.path
        variants={buttonVariants}
        initial="initial"
        animate={buttonController}
        fill="#fff"
        d="m163.044 218.902-4.204-3.301c-1.145-.801-1.84-2.138-1.84-3.608 0-2.361 1.758-4.277 3.925-4.277.491 0 .94.089 1.39.267.02 0 .031.011.041.023.01.011.02.022.041.022l5.764 2.628.123-.445.491-18.979c0-2.316 1.758-4.232 3.925-4.232s3.925 1.916 3.925 4.232l.327 7.529 3.626 1.392A29.966 29.966 0 0 0 182 191c0-16.569-13.431-30-30-30-16.569 0-30 13.431-30 30 0 16.569 13.431 30 30 30 3.9 0 7.626-.744 11.044-2.098Z"
      />
      <motion.path
        variants={buttonVariants}
        initial="initial"
        animate={buttonController}
        fill="#fff"
        d="M160.925 210.3c-.859 0-1.554.757-1.554 1.693 0 .579.286 1.114.736 1.425.041 0 .041.045.082.045l10.466 8.197c.041.045.082.045.082.089.041 0 2.862 2.629 8.3 2.629h4.088c.695-.045 5.806-.579 5.806-7.306v-8.91c0-1.248-.736-2.362-1.799-2.807l-11.693-4.455a1.24 1.24 0 0 1-.777-1.159l-.368-8.42v-.044c0-.936-.695-1.693-1.553-1.693-.859 0-1.554.757-1.554 1.693l-.491 19.201c0 .089 0 .223-.041.312l-.572 1.96c-.082.357-.327.668-.613.802-.286.178-.654.178-.981.045l-6.91-3.163c-.041 0-.041 0-.082-.045-.204-.045-.368-.089-.572-.089Z"
      />
    </motion.svg>
  );
};

export default StepFourDiagram;
